import { matchRouteName, pageState } from '@helpers/page-state';
import axios from 'axios';
import _ from 'lodash';

const mapPagination = (obj) => {
    const pagination = _.pick(obj, ['draw', 'start', 'length', 'recordsTotal', 'recordsFiltered', 'currentPage']);
    pagination.limitButtons = 7;
    return pagination;
};

const state = (matchRouteName('ads.search-keyword') || matchRouteName('ads.search-keyword-map')) && {
    ads: pageState.ads.data,
    pagination: mapPagination(pageState.ads),
    virtualResults: pageState.ads.recordsFiltered,
    mapData: pageState.ads.mapData,
    searchHeading1: pageState.ads.searchHeading1,
    storeFilters: pageState.filters,
    defaults: pageState.defaults,
    adCategory: pageState.adCategory,
    featuredAds: pageState.featuredAds,
};

const actions = {
    fetchAds({ state, commit, rootState }, filters) {
        let url = `/api/search/${state.adCategory.slug}`;
        if (rootState.area.area) {
            url += `/${rootState.area.area.slug}`;
        }
        return axios.post(url, filters)
            .then(({ data }) => {
                commit('setAds', data.data);
                commit('setPagination', data);
                commit('setVirtualResults', data.recordsFiltered);
                commit('setMapData', data.mapData);
                commit('setSearchHeading1', data.searchHeading1);
                commit('setFeaturedAds', data.featuredAds);
            });
    },
    fetchVirtualResults({ state, commit, rootState }, filters) {
        let url = `/api/search/${state.adCategory.slug}`;
        if (rootState.area.area) {
            url += `/${rootState.area.area.slug}`;
        }
        axios.post(url, { ...filters, options: { only_count_results: true } })
            .then(({ data }) => {
                commit('setVirtualResults', data);
            });
    },
};

const mutations = {
    setAds(state, payload) {
        state.ads = payload;
    },
    setPagination(state, payload) {
        state.pagination = mapPagination(payload);
    },
    setMapData(state, payload) {
        state.mapData = payload;
    },
    setVirtualResults(state, payload) {
        state.virtualResults = payload;
    },
    setSearchHeading1(state, payload) {
        state.searchHeading1 = payload;
    },
    setFeaturedAds(state, payload) {
        state.featuredAds = payload;
    },
};

const getters = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
